<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <rect
            class="a"
            x="0.75"
            y="0.75"
            width="22.5"
            height="22.5"
            rx="1.5"
            ry="1.5"
        />

        <line class="a" x1="15.75" y1="11.265" x2="15.75" y2="5.265" />

        <line class="a" x1="15.75" y1="18.765" x2="15.75" y2="15.765" />

        <path
            class="b"
            d="M18,13.515a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,18,13.515Z"
        />

        <line class="a" x1="8.25" y1="9.765" x2="8.25" y2="18.765" />

        <path
            class="b"
            d="M10.5,7.515a2.25,2.25,0,1,0-2.25,2.25A2.25,2.25,0,0,0,10.5,7.515Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'SettingsSliderFramedIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a,
.b {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}

.b {
    fill-rule: evenodd;
}
</style>
